import {preparedToRowMeta} from './dailyPhotos.js';
import type {PreparedPhoto} from './dailyPhotos.js';

export async function photoDigest(blob: Blob): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', await blob.arrayBuffer());
  return [...new Uint8Array(digest)].map((byte) => byte.toString(16).padStart(2, '0')).join('');
}

// Photo paths alone cannot distinguish different bytes supplied under the same
// retry identity. Bind the compressed bytes once and retain that digest on replay.
export async function queuedReportPhotoMetadata(prepared: PreparedPhoto[]) {
  const metadata = preparedToRowMeta(prepared);
  return Promise.all(
    prepared.map(async (photo, index) => ({...metadata[index], sha256: await photoDigest(photo.blob)})),
  );
}
